<template>
  <TsModal
    v-model:visible="couponModalVisible"
    append-class="relative px-4 overflow-hidden max-w-[calc(100dvw-10%)] xl:max-w-lg"
    :data-testid="props.dataTestid"
    @hide="couponModalVisible = false"
  >
    <template #modal-content>
      <div class="text-center relative z-10 p-6">
        <button
          class="text-idle-black bg-transparent hover:text-natural-dark-grey hover:bg-natural-light-grey/80 absolute top-3.5 right-0 rounded-md w-8 h-8 inline-flex justify-center items-center transition-colors"
          :data-testid="props.dataTestid + '-close-icon'"
          @click.stop="couponModalVisible = false"
        >
          <TsIcon name="mdi:close" size="24" />
        </button>
        <TsImage
          src="/images/applied-coupon.webp"
          width="27"
          class="inline text-center mb-2"
          loading="lazy"
          :data-testid="props.dataTestid + '-applied-success-image'"
        />
        <TsTypography
          v-if="promoCode"
          variant="sm"
          append-class="mb-2"
          weight="semibold"
          :data-testid="props.dataTestid + '-applied-code-announcer'"
          >'{{ promoCode }}'
          <span class="capitalize">
            {{ useTranslation('discount', 'Korting') }}
          </span>
        </TsTypography>
        <TsTypography
          v-if="totalSavings"
          append-class="mb-2 text-idle-black"
          variant="h2"
          weight="semibold"
          :data-testid="props.dataTestid + '-total-savings'"
        >
          <span> {{ useTranslation('Trolley-savedInTotal', 'Totale korting') }}: </span>
          € {{ totalSavings }}
        </TsTypography>
        <TsTypography
          variant="sm"
          append-class="mb-5 text-natural-dark-grey"
          :data-testid="props.dataTestid + '-descriptive-message'"
        >
          {{ message || `${defaultMessage}.` }}
        </TsTypography>
        <TsButton
          outlined
          :label="continueCTALabel"
          append-class="mb-2"
          :data-testid="props.dataTestid + '-continue-cta'"
          @click="couponModalVisible = false"
        />
      </div>
      <div class="absolute top-0 left-0 w-full z-0">
        <TsImage
          src="/images/party.webp"
          class="w-full"
          loading="lazy"
          :data-testid="props.dataTestid + '-confetti'"
        />
      </div>
    </template>
  </TsModal>
</template>

<script setup lang="ts">
import { useTranslation } from '~/composables/useTranslation';

const couponModalVisible = defineModel<boolean>('visible');

type Props = {
  promoCode?: string;
  totalSavings?: string;
  message?: string;
  dataTestid: string;
};

const props = withDefaults(defineProps<Props>(), {
  promoCode: '',
  totalSavings: '',
  message: '',
});

const continueCTALabel = useTranslation('continue', 'Doorgaan');

const defaultMessage = useTranslation('discountSuccess', 'korting is succesvol toegepast');
</script>
